'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { clearLogoutQueries } from '../providers/queryClient';
import { logoutUser } from '../utils/logout';
import { useAuth0Logout } from './useAuth0Logout';
import { useAuth0SessionLogout } from './useAuth0SessionLogout';
import { useDecisions } from './useDecisions';
export type UseLogoutOptions = {
  callback?: () => void;
  /** Redirect URL used by the legacy logout path when Auth0 is disabled. */
  redirectUrl?: string;
  skipRedirect?: boolean;
  forceRedirect?: boolean;
};

/**
 * Unified logout hook that delegates to Auth0 or the legacy logout path
 * depending on the `auth0` feature flag.
 */
export function useLogout() {
  const $ = _c(5);
  const isAuth0Enabled = useDecisions("auth0");
  const auth0Logout = useAuth0Logout();
  const auth0SessionLogout = useAuth0SessionLogout();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== auth0Logout || $[1] !== auth0SessionLogout || $[2] !== isAuth0Enabled || $[3] !== queryClient) {
    t0 = async t1 => {
      const {
        callback,
        redirectUrl: t2,
        skipRedirect,
        forceRedirect
      } = t1 === undefined ? {} : t1;
      const redirectUrl = t2 === undefined ? "/sign-in" : t2;
      if (isAuth0Enabled) {
        if (skipRedirect) {
          await auth0SessionLogout({
            callback,
            skipRedirect,
            redirectUrl
          });
        } else {
          await auth0Logout({
            callback
          });
        }
      } else {
        await logoutUser({
          redirectUrl,
          skipRedirect,
          forceRedirect,
          callback: () => {
            callback?.();
            clearLogoutQueries(queryClient);
          }
        });
      }
    };
    $[0] = auth0Logout;
    $[1] = auth0SessionLogout;
    $[2] = isAuth0Enabled;
    $[3] = queryClient;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}